import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Realizas el Reset Térmico',
    desc: 'Aplicas la técnica de la ducha de contraste y el calcetín térmico para enfriar tu cerebro.'
  }, {
    num: '2',
    title: 'Cierras la Ventana de Cortisol',
    desc: 'Sigues el protocolo de alimentación y apagón digital 90 minutos antes de acostarte.'
  }, {
    num: '3',
    title: 'Sincronizas tu Reloj Maestro',
    desc: 'Usas la luz solar matutina para fijar tu ritmo y garantizar el sueño de la noche siguiente.'
  }];
  return <section className="py-24 px-4 md:px-8 bg-nightBlue" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-75">
          <h2 className="font-playfair font-bold text-3xl md:text-4xl text-warmWhite mb-4" data-id="element-76">
            Cómo funciona el protocolo
          </h2>
          <p className="font-lato text-lg text-warmWhite/70" data-id="element-77">
            Tres pasos simples basados en tu biología natural.
          </p>
        </motion.div>

        <div className="space-y-8 relative" data-id="element-78">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute left-[39px] top-10 bottom-10 w-0.5 bg-gradient-to-b from-teal via-teal/50 to-transparent" data-id="element-79" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex flex-col md:flex-row gap-6 md:gap-8 relative z-10" data-id="element-80">
              <div className="flex-shrink-0 w-20 h-20 rounded-full bg-nightBlueLighter border-2 border-teal flex items-center justify-center shadow-[0_0_15px_rgba(78,205,196,0.2)]" data-id="element-81">
                <span className="font-montserrat font-bold text-3xl text-teal" data-id="element-82">
                  {step.num}
                </span>
              </div>
              <div className="pt-4 pb-8 md:pb-12" data-id="element-83">
                <h3 className="font-montserrat font-semibold text-xl md:text-2xl text-warmWhite mb-3" data-id="element-84">
                  {step.title}
                </h3>
                <p className="font-lato text-base md:text-lg text-warmWhite/80 leading-relaxed" data-id="element-85">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}